import { Building2, MapPinned, Package2, Truck, Users } from "lucide-react";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { DriversPage } from "./DriversPage";
import { LocationsPage } from "./LocationsPage";
import { TrailersPage } from "./TrailersPage";
import { TrucksPage } from "./TrucksPage";

const tabs = [
  { value: "drivers", label: "Drivers", icon: Users, content: <DriversPage /> },
  { value: "trucks", label: "Trucks", icon: Truck, content: <TrucksPage /> },
  { value: "trailers", label: "Trailers", icon: Package2, content: <TrailersPage /> },
  { value: "locations", label: "Locations", icon: MapPinned, content: <LocationsPage /> },
];

export default function RecordsPage() {
  return (
    <div className="space-y-6" data-testid="records-page">
      <section className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-zinc-500">Shared records</p>
          <h1 className="mt-2 text-4xl font-semibold text-zinc-900">Records</h1>
          <p className="mt-2 max-w-3xl text-sm text-zinc-500">Keep drivers, trucks, trailers, and saved locations together in one office-ready records area.</p>
        </div>
        <div className="rounded-3xl border border-zinc-200 bg-zinc-50 px-4 py-4" data-testid="records-summary-card">
          <div className="flex items-center gap-2 text-zinc-700">
            <Building2 className="h-4 w-4" />
            <p className="text-sm">Everything dispatch needs for assignments and repeat loads lives here.</p>
          </div>
        </div>
      </section>

      <Tabs className="space-y-6" data-testid="records-tabs" defaultValue="drivers">
        <TabsList className="flex h-auto w-full flex-wrap justify-start gap-2 rounded-3xl border border-zinc-200 bg-white p-2" data-testid="records-tabs-list">
          {tabs.map(({ value, label, icon: Icon }) => (
            <TabsTrigger className="rounded-2xl px-4 py-3" data-testid={`records-tab-${value}`} key={value} value={value}>
              <span className="inline-flex items-center gap-2">
                <Icon className="h-4 w-4" /> {label}
              </span>
            </TabsTrigger>
          ))}
        </TabsList>

        {tabs.map(({ value, content }) => (
          <TabsContent data-testid={`records-tab-content-${value}`} key={value} value={value}>
            {content}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}